export const moments = [
  {
    id: "m1",
    title: "话筒失灵的三秒钟",
    desc: "伴奏突然中断，全场安静三秒，随后一段清唱把气氛拉了回来。这个片段成了全年回放量最高的救场名场面。",
    category: "舞台救场",
    year: 2025,
    heat: 98,
    topicSlug: "top-ten-moments-2025",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20empty%20stage%20microphone%20under%20a%20single%20warm%20amber%20spotlight%2C%20deep%20coral%20curtain%20background%2C%20cinematic%20moody%20minimal%20composition%2C%20no%20people&width=800&height=800&seq=gt-moment-mic&orientation=squarish",
  },
  {
    id: "m2",
    title: "最后一秒的逆转",
    desc: "落后整场的队伍在计时器归零前完成反超，解说一度失声。竞技类名场面的教科书级样本。",
    category: "竞技反转",
    year: 2025,
    heat: 95,
    topicSlug: "variety-moments-annual",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20stopwatch%20and%20scoreboard%20glow%20against%20dark%20arena%2C%20amber%20and%20coral%20light%20streaks%2C%20dynamic%20minimal%20composition%2C%20no%20text%2C%20no%20people&width=800&height=800&seq=gt-moment-reverse&orientation=squarish",
  },
  {
    id: "m3",
    title: "全场沉默的对视",
    desc: "没有台词的三秒沉默，两个人只是对看了一眼，弹幕却刷满了屏幕。真实反应比台词更有力量。",
    category: "慢综艺",
    year: 2025,
    heat: 91,
    topicSlug: "variety-moments-annual",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20two%20empty%20wooden%20chairs%20facing%20each%20other%20in%20soft%20warm%20room%20light%2C%20plum%20and%20amber%20tones%2C%20quiet%20editorial%20still%20life%2C%20no%20people&width=800&height=800&seq=gt-moment-gaze&orientation=squarish",
  },
  {
    id: "m4",
    title: "抢答口误笑翻全场",
    desc: "把题目里的关键词听岔了，答案一出全场爆笑。至今仍是二创使用率最高的综艺片段之一。",
    category: "综艺翻车",
    year: 2025,
    heat: 88,
    topicSlug: "top-ten-moments-2025",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20bright%20quiz%20buzzer%20and%20colorful%20answer%20cards%20scattered%20on%20cream%20table%2C%20playful%20coral%20and%20amber%20palette%2C%20editorial%20flat%20lay%2C%20no%20text&width=800&height=800&seq=gt-moment-blunder&orientation=squarish",
  },
  {
    id: "m5",
    title: "改编成乐队版的抒情歌",
    desc: "把一首慢歌改成现场乐队版本，副歌一进全场起立。改编争议与惊艳只隔了一层编曲。",
    category: "舞台改编",
    year: 2025,
    heat: 86,
    topicSlug: "stage-adaptation-copyright",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20electric%20guitar%20silhouette%20and%20drum%20kit%20under%20amber%20stage%20haze%2C%20coral%20backlight%2C%20energetic%20minimal%20poster%20style%2C%20no%20people&width=800&height=800&seq=gt-moment-band&orientation=squarish",
  },
  {
    id: "m6",
    title: "团综集体破防",
    desc: "一群人围坐回忆过往，有人先红了眼眶，接着全场沉默。群像名场面的代表作，情绪浓度拉满。",
    category: "团综高光",
    year: 2025,
    heat: 83,
    topicSlug: "variety-moments-annual",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20circle%20of%20empty%20stools%20around%20warm%20campfire%20glow%20at%20night%2C%20amber%20and%20plum%20tones%2C%20cozy%20cinematic%20minimal%20scene%2C%20no%20people&width=800&height=800&seq=gt-moment-group&orientation=squarish",
  },
  {
    id: "m7",
    title: "临场救场的接梗",
    desc: "嘉宾说错话，主持人一句话圆了回来，全程不到两秒。被网友称为年度最丝滑的接梗现场。",
    category: "临场反应",
    year: 2025,
    heat: 80,
    topicSlug: "top-ten-moments-2025",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20studio%20microphone%20and%20cue%20cards%20on%20a%20dark%20warm%20desk%2C%20amber%20rim%20light%2C%20editorial%20minimal%20still%20life%2C%20no%20text%2C%20no%20people&width=800&height=800&seq=gt-moment-save&orientation=squarish",
  },
  {
    id: "m8",
    title: "直播意外掉线又上线",
    desc: "直播中途掉线，重新连上后画风突变，观众把这段剪成了各种版本。意外的才是最好的素材。",
    category: "直播意外",
    year: 2024,
    heat: 76,
    topicSlug: "2024-year-in-review",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20glowing%20live%20signal%20waves%20and%20screen%20glitch%20pattern%20on%20dark%20warm%20background%2C%20coral%20and%20amber%20neon%20accents%2C%20minimal%20concept%20art%2C%20no%20text&width=800&height=800&seq=gt-moment-live&orientation=squarish",
  },
  {
    id: "m9",
    title: "后台花絮里的真实相处",
    desc: "正片里客客气气，花絮里互相拆台。很多观众说，花絮比正片好看，因为更真实。",
    category: "花絮名场面",
    year: 2024,
    heat: 72,
    topicSlug: "2024-year-in-review",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20backstage%20makeup%20mirror%20with%20warm%20bulbs%20and%20hanging%20costumes%2C%20amber%20and%20plum%20tones%2C%20editorial%20atmospheric%20still%20life%2C%20no%20people&width=800&height=800&seq=gt-moment-backstage&orientation=squarish",
  },
];

export const momentCategories = [
  "全部",
  "舞台救场",
  "舞台改编",
  "竞技反转",
  "综艺翻车",
  "慢综艺",
  "团综高光",
  "临场反应",
  "直播意外",
  "花絮名场面",
];

export const collections = [
  {
    title: "年度补课入门包",
    desc: "半小时建立整体印象，先看名场面再看年度盘点。",
    count: 6,
    icon: "ri-graduation-cap-line",
    topicSlug: "collection-top-ten-must-watch",
  },
  {
    title: "争议事件时间线合集",
    desc: "所有涉及多方的争议，按时间顺序一次看明白。",
    count: 14,
    icon: "ri-history-line",
    topicSlug: "contract-season-cases",
  },
  {
    title: "二创高播放量合集",
    desc: "被剪得最多、回放量最高的片段打包入口。",
    count: 22,
    icon: "ri-scissors-cut-line",
    topicSlug: "variety-moments-annual",
  },
  {
    title: "人物成长曲线合集",
    desc: "以人物为主线，串起几年间的关键节点。",
    count: 9,
    icon: "ri-line-chart-line",
    topicSlug: "person-profile-rising-curve",
  },
];